import React, { FC } from 'react';
import { Typography, TypographyProps } from '@cp/ds/components/typography';
import { styled } from '@cp/ui/theme';
import { getCssVar } from '@cp/ui/utils';

const Root = styled(Typography)({ textAlign: 'center', display: 'block', marginBlockEnd: getCssVar('Section', 'header-offset') });

export interface SectionHeaderProps extends TypographyProps {}
export const SectionHeader: FC<SectionHeaderProps> = (props) => <Root variant="h2" {...props} />;
